export default __webpack_public_path__ + "static/media/Savant's Tunic of the Burning Disc.5e564c37.jpg";